import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/components/saas-ui/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/components/startup-ui/navbar.tsx");
